function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 10h-.5v0c-1.396 0-2.093 0-2.661.172a4 4 0 00-2.667 2.667C2 13.407 2 14.104 2 15.5v.5c0 1.864 0 2.796.304 3.53a4 4 0 002.165 2.165C5.204 22 6.136 22 8 22h8c1.864 0 2.796 0 3.53-.305a4 4 0 002.165-2.164C22 18.796 22 17.864 22 16v-.5c0-1.396 0-2.093-.172-2.661a4 4 0 00-2.667-2.667C18.593 10 17.896 10 16.5 10v0H16m-4 5V2m0 0L8 6m4-4l4 4",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#2F384C"
  }, props), _ref);
};

export default SvgExport;